export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-ink border-t border-line-d py-14" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex flex-col md:flex-row justify-between gap-8">
        <div>
          <div className="font-display text-2xl text-sand">Beyond the Mask</div>
          <p className="mt-3 max-w-sm text-muted-d text-sm leading-relaxed">
            Vulnerability &amp; authenticity workshops for corporate organisations seeking deeper trust and connection.
          </p>
        </div>
        <div className="flex flex-col md:items-end justify-between gap-4">
          <div className="flex flex-col md:items-end gap-1">
            <a href="mailto:tal@beyondthemask.com.au" className="font-display text-xl text-sand hover:text-terra transition-colors duration-300" data-testid="footer-email">
              tal@beyondthemask.com.au
            </a>
            <a href="tel:+61430095792" className="font-display text-xl text-sand hover:text-terra transition-colors duration-300" data-testid="footer-phone">
              0430 095 792
            </a>
          </div>
          <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-d">
            © {year} Beyond the Mask · Made with intention
          </span>
        </div>
      </div>
    </footer>
  );
}
